import { render, staticRenderFns } from "./GarageTable.vue?vue&type=template&id=4b81ef29&scoped=true"
import script from "./GarageTable.vue?vue&type=script&lang=js"
export * from "./GarageTable.vue?vue&type=script&lang=js"
import style0 from "./GarageTable.vue?vue&type=style&index=0&id=4b81ef29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b81ef29",
  null
  
)

export default component.exports